import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=08e4f82f&scoped=true"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"
import style0 from "./DatePicker.vue?vue&type=style&index=0&id=08e4f82f&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e4f82f",
  null
  
)

export default component.exports